import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { logEvent } from '@eventbrite/statsig';
import {
    trackBrandClick,
    trackEndOfCheckoutFormViewed,
} from '../actions/eventAnalytics';
import PoweredByEventbriteText from '../components/poweredByEventbriteText/PoweredByEventbriteText';
import { STATSIG_EVENT_NAMES } from '../constants/statsig';
import { getCheckoutStepFromPath } from '../utils/analytics';
import { getIsPaymentView } from '../selectors/routing';

export default flowRight(
    withRouter,
    connect(
        (state) => ({
            locale: state.app.locale,
            isCheckoutForm: getIsPaymentView(state),
        }),
        (dispatch, { router }) => ({
            onClick: () =>
                dispatch(
                    trackBrandClick(
                        getCheckoutStepFromPath(
                            router.getCurrentLocation().pathname,
                        ),
                    ),
                ),
            onTextShown: () => {
                dispatch(trackEndOfCheckoutFormViewed());
                logEvent(
                    STATSIG_EVENT_NAMES.CHECKOUT_STEP_END_CHECKOUT_FORM_VIEW,
                );
            },
        }),
    ),
)(PoweredByEventbriteText);
